<template>
  <div v-if="loading"><spinner class="car-spinner car-content-spinner" /></div>
  <div v-else-if="!loading && !requestErr">
    <div class="car-reviews">
      <div
        class="car-review"
        data-js="booking-comment"
        v-for="(comment, index) in comments"
        v-show="display.extraComments || (index < 2)"
        :key="index"
      >
        <div class="car-review-comment">
          <div class="car-items">
            <div class="car-item">
              <span class="car-rating"><ratings :rating="comment.averageRating"></ratings></span>
              <span class="car-date">{{comment.created.time | moment('L')}}</span>
              <span class="car-comment">{{comment.comment}}</span>
            </div>
          </div>
        </div>
        <div class="car-review-details" v-show="display['commentDetails-'+comment.id]">
          <div class="car-service-details" v-show="comment.serviceList || comment.services.length">
            <div class="car-list">
              <span class="car-list-label">{{$t('booking.summary.services')}}</span>
              <div class="car-items">
                <div class="car-item" v-for="service in comment.services" :key="service.id">
                  <span class="car-text">{{service | optionTranslate}}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="car-vehicle-details" v-show="comment.vehicle">
            <div class="car-list">
              <span class="car-list-label">{{$t('booking.summary.vehicle')}}</span>
              <div class="car-items">
                <div class="car-item">
                  <span class="car-text">{{comment.vehicle}}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="car-rating-details">
            <div class="car-list">
              <div class="car-items">
                <div class="car-item">
                  <span class="car-label">{{$t('booking.ratings.feeling')}}</span>
                  <span class="car-rating"><ratings :rating="comment.bookedOfferVotingTypeMap.OVERALL_FEELING[0]"></ratings></span>
                </div>
                <div class="car-item">
                  <span class="car-label">{{$t('booking.ratings.reliability')}}</span>
                  <span class="car-rating"><ratings :rating="comment.bookedOfferVotingTypeMap.DETAIL_RELIABILITY[0]"></ratings></span>
                </div>
                <div class="car-item">
                  <span class="car-label">{{$t('booking.ratings.quality')}}</span>
                  <span class="car-rating"><ratings :rating="comment.bookedOfferVotingTypeMap.DETAIL_QUALITY[0]"></ratings></span>
                </div>
                <div class="car-item">
                  <span class="car-label">{{$t('booking.ratings.friendliness')}}</span>
                  <span class="car-rating"><ratings :rating="comment.bookedOfferVotingTypeMap.DETAIL_FRIENDLINESS[0]"></ratings></span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="car-review-links" @click="toggle('commentDetails-'+comment.id)">
          <div class="car-link car-close" v-show="display['commentDetails-'+comment.id]"><span class="car-text">{{$t('booking.comments.less')}}</span><span class="car-icon"></span></div>
          <div class="car-link car-open" v-show="!display['commentDetails-'+comment.id]"><span class="car-text">{{$t('booking.comments.more')}}</span><span class="car-icon"></span></div>
        </div>
      </div>
    </div>

    <div
      class="car-reviews-links"
      v-show="comments.length > 2"
      @click="toggle('extraComments')"
    >
      <span class="car-link" v-show="display.extraComments">{{$t('booking.comments.recent')}}</span>
      <span class="car-link" v-show="!display.extraComments">
        <!-- TODO: check how to pass variable to translation key -->
        {{$t('booking.comments.all')}}
      </span>
    </div>
  </div>
  <div class="car-error-message" v-else>
    {{$t('errors.unknown')}}
  </div>
</template>

<script>
import Ratings from '@/components/service-request/Ratings';
import { merge } from 'lodash';
import bookingApiService from '@/services/bookingApiService';
import Spinner from 'vue-simple-spinner';

export default {
  name: 'WorkshopReview',
  data() {
    return {
      comments: [],
      display: {
        extraComments: false
      },
      loading: false,
      requestErr: false
    }
  },
  props: {
    locationId: {
      required: true
    }
  },
  created() {
    this.loading = true;
    this.requestErr = false;
    this.getLocationVotings(this.locationId)
      .catch(() => { this.requestErr = true; })
      .finally(() => { this.loading = false; })
  },
  methods: {
    toggle: function (section) {
      this.display[section] = !this.display[section];
    },
    getLocationVotings(locationId) {
      return bookingApiService.getLocationVoting(locationId).then((res) => {
        this.comments = res.data;
        // set all comments to display overview only
        for (let i = 0; i < this.comments.length; i++) {
          this.$set(this.display, 'commentDetails-' + this.comments[i].id, false);
          this.comments[i].bookedOfferVotingTypeMap = merge({
            DETAIL_RELIABILITY: ['0'],
            DETAIL_QUALITY: ['0'],
            DETAIL_FRIENDLINESS: ['0'],
            OVERALL_FEELING: ['0']
          }, this.comments[i].bookedOfferVotingTypeMap);
          if (this.comments[i].comment) {
            this.comments[i].comment = this.comments[i].comment.trim();
          } else {
            this.comments[i].comment = null;
          }
        }
      });
    }
  },
  components: {
    Ratings,
    Spinner
  }
}
</script>
